import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { isEmpty, get, camelCase } from "lodash";
import { Button, Form, Image } from "react-bootstrap";
import { faShareSquare } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  ManageEligibilityLayout,
  LoaderWrapper,
  CsplTable as Table,
  FieldDropSide,
  DatePicker,
  SearchableList,
  SliderPanel,
  AddToolTip,
} from "../../../components";
import {
  manageEligibilityFormNames,
  MANAGE_ELIGIBILITY_ROUTES,
  getPathWithParam,
  formFields,
  getFlowBasedFormValues,
  usDateFormat,
  required,
  EMPLOYEE_RECORDS_TO_FETCH,
  clearFieldValues,
} from "../../../utils";
import { useRouterParams, useRequest, useDeepEffect } from "../../../abstracts";
import {
  getCompaniesList,
  getEligibilitySummaryReport,
  getPlanList,
} from "../../../services";
import {
  manageEligibilityStore,
  setManagePageLevelData,
} from "../../../contexts";
import { Formik, Field } from "formik";
import company from "../../../mocks/company.json";
import plan from "../../../mocks/planName.json";
import { CSVLink } from "react-csv";
import RunEligibilityProcessSlider from "./RunEligibilityProcessSlider";
import { getSummaryReport } from "../../../services/payroll/index";
import { date } from "yup";
import moment from "moment";
import permissions from "../../../mocks/menuPermissions.json";
import authService from "../../../components/api-authorization/AuthorizeService";
import InfiniteScroll from "react-infinite-scroller";
import ExcelImage from "../../../styles/exportimg.PNG";

const initialValues = {};

const columns = [
  {
    label: "Company name",
    className: "column-companyName",
    columnName: "companyName",
  },
  {
    label: "Plan ID",
    className: "column-planId",
    columnName: "rkPlanNumber",
  },
  {
    label: "Plan name",
    className: "column-planName",
    columnName: "planName",
  },
  {
    label: "Participants eligible for plan",
    className: "column-statusPlan",
    columnName: "planCount",
    link: `${MANAGE_ELIGIBILITY_ROUTES.NEW_EMPLOYEE_ELIGIBILITY_REPORT}`,
  },
  {
    label: "Participants eligible for sources",
    className: "column-statusSource",
    columnName: "sourceCount",
    link: `${MANAGE_ELIGIBILITY_ROUTES.NEW_EMPLOYEE_ELIGIBILITY_REPORT}`,
  },
  {
    label: "Process date",
    className: "column-processDate",
    columnName: "processDate",
  },
];

const planOptions = ["Plan ID", "Plan name"];

const EligibilitySummaryReportsContainer = (props) => {
  const { menu, subMenu } = props;
  const [isModalOpen, setModalOpen] = useState(false);
  const { flow, planId } = useRouterParams();
  const { state, dispatch } = useContext(manageEligibilityStore);
  const [isLoading, setIsLoading] = useState(false);
  const [planList, setPlanList] = useState([]);
  const allOption = { label: "All", value: null };
  const [plan, setPlan] = useState();
  const [eligibilitySummaryReport, setEligibilitySummaryReport] = useState([]);
  const [planOption, setPlanOption] = useState(0);
  const [append, setAppend] = useState(false);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const [total, setTotal] = useState();

  const { response: companies } = useRequest({
    method: getCompaniesList,
    payload: 1, //TenantId. HardCoding should be removed
    defaultResponse: [],
  });
  useDeepEffect(() => {
    getPlanList(0)
      .then((response) => {
        setPlanList(response);
      })
      .catch((error) => {});
  }, []);
  const formName = manageEligibilityFormNames.ELIGIBILITY_SUMMARY_FILTER;
  const fields = formFields[formName];

  const onAddClick = () => {};
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  const buttons = [
    // {
    //   label: "Export",
    //   variant: "secondary",
    //   type: "button",
    //   onClick: onAddClick,
    // },
  ];

  const onFormSubmit = (values) => {
    dispatch(
      setManagePageLevelData({
        formName: formName,
        fieldData: values,
      })
    );
  };
  const [apiRequest, setApiRequest] = useState({
    companyId: 0,
    planId: 0,
    from: 0,
    to: parseInt(EMPLOYEE_RECORDS_TO_FETCH),
  });
  // const initialValues = {
  //   [fields.startDate]: new Date(),
  //   [fields.endDate]: new Date(new Date(). getFullYear(), new Date(). getMonth(), new Date(). getDate()+7),
  // };
  useDeepEffect(() => {
    if (apiRequest.companyId != 0) {
      setIsLoading(true);
      getSummaryReport(apiRequest)
        .then((response) => {
          setTotal(response.totalCount);
          if (
            response?.eligibilitySummaryReportData.length <
            EMPLOYEE_RECORDS_TO_FETCH
          )
            setStopInfiniteScroll(true);
          if (append)
            setEligibilitySummaryReport((eligibilitySummaryReport) => {
              return [
                ...eligibilitySummaryReport,
                ...response.eligibilitySummaryReportData,
              ];
            });
          else {
            setEligibilitySummaryReport(response.eligibilitySummaryReportData);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          //Handle Errors
          setIsLoading(false);
        });
    }
  }, [apiRequest]);

  const onFilter = (values) => {
    setIsLoading(true);
    // setTimeout(() => {
    //   setIsLoading(false);
    // }, 1000);
    setEligibilitySummaryReport([]);
    setApiRequest({
      ...apiRequest,
      companyId: parseInt(values.companyId),
      planId: values.planId,
      fromDate: values.startDate,
      toDate: values.endDate,
      from: 0,
      to: parseInt(EMPLOYEE_RECORDS_TO_FETCH),
    });
    setStopInfiniteScroll(false);
    // getSummaryReport(apiRequest)
    //   .then((response) => {
    //     setIsLoading(false);
    //     setEligibilitySummaryReport(response);
    //   })
    //   .catch((error) => {
    //     setIsLoading(false);
    //   });
  };
  const onViewButtonClick = () => {
    setModalOpen(!isModalOpen);
  };

  return (
    <ManageEligibilityLayout buttons={buttons}>
      <div className="eligibility-container">
        <CSVLink data={eligibilitySummaryReport}>
          {/* <FontAwesomeIcon icon={faShareSquare} color="#212529" /> */}
          Export
        </CSVLink>
      </div>
      <LoaderWrapper isLoading={isLoading}>
        {
          <div className="w-100">
            <div className="d-flex w-100 align-items-center justify-content-between mb-4">
              <div className="m-0 plan-heading font-weight-500">
                Summary Reports
              </div>
              <div className="m-0 plan-heading font-weight-500">
                {permissions[roleName][menu + "SubMenu"][
                  camelCase(subMenu)
                ]?.includes("C") &&
                  permissions[roleName][menu + "SubMenu"][
                    camelCase(subMenu)
                  ]?.includes("U") && (
                    <Button onClick={onViewButtonClick}>
                      Run Eligibility Process
                    </Button>
                  )}
              </div>
            </div>

            <Formik
              initialValues={{
                ...initialValues,
                ...getFlowBasedFormValues(get(state, formName, {}), flow),
              }}
              onSubmit={onFormSubmit}
              enableReinitialize
              validateOnChange={false}
              validateOnBlur={false}
            >
              {({
                handleChange,
                setFieldValue,
                handleSubmit,
                values,
                setValues,
                ...rest
              }) => {
                const onDaySelected = (fieldName, value) => {
                  setFieldValue(fieldName, value);
                };
                const onCompanyChange = (value, plan) => {
                  setValues({
                    ...clearFieldValues({
                      values: values,
                      fieldsToExculde: [fields.fromDate, fields.toDate],
                      fieldsToClear: plan
                        ? [fields.rkPlanNumber, fields.planId, fields.planName]
                        : [],
                    }),
                    [fields.companyId]:
                      value || value === 0 ? parseInt(companies[value].id) : 0,
                    [fields.companyName]:
                      value || value === 0 ? companies[value].name : "All",
                    [fields.rkPlanNumber]: plan ? plan.rkPlanNumber : "All",
                    [fields.planId]: plan ? plan.id : 0,
                    [fields.planName]: plan ? plan.name : "All",
                  });
                  getPlanList(get(companies[value], "id", 0)).then(
                    (response) => {
                      if (response.length == 1) {
                        setFieldValue(fields.planId, parseInt(response[0].id));
                        setFieldValue(
                          fields.rkPlanNumber,
                          response[0].rkPlanNumber
                        );
                        setFieldValue(fields.planName, response[0].name);
                        setPlanList(response);
                      } else {
                        setPlanList(response);
                        setFieldValue(fields.planId, 0);
                        setFieldValue(fields.rkPlanNumber, "All");
                        setFieldValue(fields.planName, "All");
                      }
                    }
                  );
                };

                const onPlanChange = (value) => {
                  console.log("value", value);

                  if (value || value === 0) {
                    var temp = planList.filter((x) => x.id == value);
                    setFieldValue(fields.planName, temp[0].name);
                    setFieldValue(fields.planId, parseInt(temp[0].id));
                    setFieldValue(fields.rkPlanNumber, temp[0].rkPlanNumber);

                    const companyOptions = companies.find(
                      (_) => parseInt(_.id) == temp[0].companyId
                    );

                    setFieldValue(fields.companyName, companyOptions?.name);
                    setFieldValue(fields.companyId, companyOptions?.id);
                  } else {
                    setFieldValue(fields.planName, "All");
                    setFieldValue(fields.planId, 0);
                    setFieldValue(fields.rkPlanNumber, "All");
                  }
                };
                return (
                  <Form
                    autoComplete="off"
                    className="h-100"
                    onSubmit={handleSubmit}
                    validated={!isEmpty(rest.errors)}
                  >
                    <div className="d-flex">
                      <div
                        className="d-flex mr-2 "
                        style={{ marginTop: "1px" }}
                      >
                        <Field
                          noLabelTransform
                          label="Company"
                          size="sm"
                          isRequired
                          name={fields.companyName}
                          value={values[fields.companyName]}
                          direction="bottom"
                          popupContent={
                            <SearchableList
                              label="Select Company"
                              options={[
                                allOption,
                                ...companies.map((company, index) => ({
                                  label: company.name,
                                  value: index,
                                })),
                              ]}
                              onSelect={(value) => onCompanyChange(value, null)}
                              selectedValue={values[fields.companyName]}
                            />
                          }
                          component={FieldDropSide}
                        />
                        <div style={{ marginLeft: "24px" }} className="d-flex">
                          <div
                            style={{ marginRight: "24px" }}
                            className="no-label-transform"
                          >
                            <div>
                              <Field
                                noLabelTransform
                                label="Plan name/Plan ID"
                                size="sm"
                                isRequired
                                name={fields.planName}
                                value={values[fields.planName]}
                                placeholder="Select Name or ID"
                                direction="bottom"
                                popupContent={
                                  <SearchableList
                                    label="Select plan name/ plan ID"
                                    page="managePayroll"
                                    options={
                                      planList && [
                                        {
                                          ...allOption,
                                          label1: planList.length,
                                        },
                                        ...planList.map((plan, index) => ({
                                          label: plan.name,
                                          label1: plan.rkPlanNumber,
                                          value: plan.id,
                                        })),
                                      ]
                                    }
                                    onSelect={(value) => onPlanChange(value)}
                                    selectedValue={values[fields.planName]}
                                  />
                                }
                                component={FieldDropSide}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex">
                        <div
                          className="d-flex mr-2 "
                          style={{ marginTop: "1px" }}
                        >
                          <Field
                            size="sm"
                            noLabelTransform
                            label="Date Range"
                            isRequired
                            name={fields.startDate}
                            value={usDateFormat(values[fields.startDate])}
                            isDatePicker
                            placeholder="From"
                            direction="bottom"
                            onClear={() =>
                              onDaySelected(fields.startDate, null)
                            }
                            popupContent={
                              <DatePicker
                                onDayClick={(value) =>
                                  onDaySelected(fields.startDate, value)
                                }
                                value={values[fields.startDate]}
                              />
                            }
                            component={FieldDropSide}
                          />
                        </div>
                        <div
                          className="mr-4 ml-4"
                          style={{ marginTop: "1.9rem" }}
                        >
                          <Field
                            size="sm"
                            name={fields.endDate}
                            placeholder="To"
                            value={usDateFormat(values[fields.endDate])}
                            direction="bottom"
                            isDatePicker
                            onClear={() => onDaySelected(fields.endDate, null)}
                            popupContent={
                              <DatePicker
                                onDayClick={(value) =>
                                  onDaySelected(fields.endDate, value)
                                }
                                value={values[fields.endDate]}
                              />
                            }
                            leftOffset={100}
                            component={FieldDropSide}
                          />
                        </div>
                      </div>
                      <Button
                        onClick={() => {
                          onFilter(values);
                        }}
                        className="ml-2 sort-button"
                        style={{ marginTop: "1.7rem" }}
                      >
                        Go
                      </Button>
                    </div>
                  </Form>
                );
              }}
            </Formik>

            <div className="text-right mr-4 mb-10">
              <p>
                {" "}
                {eligibilitySummaryReport.length != 0
                  ? `${eligibilitySummaryReport.length}/${total}`
                  : 0}{" "}
                Records{" "}
              </p>
            </div>

            <div className="eligibility-table">
              <Table>
                <Table.Thead>
                  <Table.Tr>
                    {columns.map((item, index) => {
                      return (
                        <Table.Th key={index} className={item.className}>
                          {item.label}
                        </Table.Th>
                      );
                    })}
                  </Table.Tr>
                </Table.Thead>

                <Table.Tbody>
                  {eligibilitySummaryReport.length === 0 && (
                    <div style={{ textAlign: "center" }}>No data available</div>
                  )}
                  <InfiniteScroll
                    pageStart={0}
                    loadMore={() => {
                      setAppend(true);
                      setApiRequest((apiRequest) => {
                        return {
                          ...apiRequest,
                          from: eligibilitySummaryReport?.length,
                        };
                      });
                    }}
                    hasMore={!stopInfiniteScroll}
                    initialLoad={false}
                    threshold={100}
                    useWindow={false}
                    loader={
                      eligibilitySummaryReport.length != 0 && (
                        <div className="loader" key={0}>
                          Loading ...
                        </div>
                      )
                    }
                  >
                    {eligibilitySummaryReport.map((source, index) => {
                      return (
                        <Table.Tr key={index}>
                          <Table.Td className="column-companyName">
                            {source.companyName}
                          </Table.Td>
                          <Table.Td className="column-planId">
                            {source.rkPlanNumber}
                          </Table.Td>
                          <Table.Td className="column-planName">
                            <AddToolTip name={source.planName}>
                              {source.planName}
                            </AddToolTip>
                          </Table.Td>
                          <Table.Td className="column-statusPlan justify-content-center">
                            <Link
                              to={getPathWithParam({
                                path: `${MANAGE_ELIGIBILITY_ROUTES.NEW_EMPLOYEE_ELIGIBILITY_REPORT}`,
                                // pathParam: [flow],
                                queryParam: `?planId=${
                                  source.planID
                                }&processId=${
                                  source.eligibilityProcessId
                                }&eligiblefor=${1}`,
                              })}
                            >
                              {source.planCount}
                            </Link>
                          </Table.Td>
                          <Table.Td className="column-statusSource justify-content-center">
                            <Link
                              to={getPathWithParam({
                                path: `${MANAGE_ELIGIBILITY_ROUTES.NEW_EMPLOYEE_ELIGIBILITY_REPORT}`,
                                // pathParam: [flow],
                                queryParam: `?planId=${
                                  source.planID
                                }&processId=${
                                  source.eligibilityProcessId
                                }&eligiblefor=${2}`,
                              })}
                            >
                              {source.sourceCount}
                            </Link>
                          </Table.Td>
                          <Table.Td className="column-processDate">
                            {usDateFormat(source.processDate) +
                              " " +
                              moment(new Date(source.processDate)).format(
                                "HH:mm:ss"
                              )}
                          </Table.Td>
                        </Table.Tr>
                      );
                    })}
                  </InfiniteScroll>
                </Table.Tbody>
              </Table>
            </div>
          </div>
        }
      </LoaderWrapper>

      <SliderPanel
        isOpen={isModalOpen}
        size="30"
        onClose={() => setModalOpen(false)}
        backdropClicked={false}
      >
        <RunEligibilityProcessSlider
          onCancel={onViewButtonClick}
          onSubmitted={onViewButtonClick}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      </SliderPanel>
    </ManageEligibilityLayout>
  );
};

export default EligibilitySummaryReportsContainer;
